import React from 'react'
import styles from './popularize.scss'
import product from '../../../common/images/product/product-9.jpg'

const Popularize = (props) => {
  return <section className={styles['popularize']}>
    <div className={styles['advanced-contnet']}>
      <div className={styles['product']}>
        <img src={product} alt='product' />
        <div>
          <h3>概而论云记账</h3>
          <p>您的票财税一体化管理专家</p>
        </div>
      </div>
      <div className={styles['characters']}>
        <h2>普及版</h2>
        <div>
          <p><span>适用群体</span></p>
          <p>个人兼职会计</p>
          <p></p>
        </div>
      </div>
      <div className={styles['advanced-table']}>
        <table border='0' cellSpacing='0' cellPadding='0' align='center' width='100%'>
          <tbody>
            <tr className={styles['table-th']}>
              <th>产品版本</th>
              <th colSpan='3'>主要功能</th>
            </tr>
            <tr>
              <td rowSpan='7' className={styles['advanced-gaoji']}><span>普及版</span></td>
              <td>单用户</td>
              <td colSpan='2' className={styles['advanced-left']}></td>
            </tr>
            <tr>
              <td rowSpan='6' className={styles['advanced-center']}><span>智能财务管理</span></td>
              <td colSpan='2' className={styles['advanced-left']}>基础账务</td>
            </tr>
            <tr>
              <td colSpan='2' className={styles['advanced-left']}>发票批量获取、电票采集</td>
            </tr>
            <tr>
              <td colSpan='2' className={styles['advanced-left']}>发票、对账智能生成凭证</td>
            </tr>
            <tr>
              <td colSpan='2' className={styles['advanced-left']}>工资管理</td>
            </tr>
            <tr>
              <td colSpan='2' className={styles['advanced-left']}>期末成本自动结转、电子归档</td>
            </tr>
            <tr>
              <td colSpan='2' className={styles['advanced-left']}>财务报表申报、个税申报</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className={styles['advanced-yd']}>
        <p><span>适用群体</span></p>
        <p>个人兼职会计</p>
      </div>
    </div>
  </section>
}

export default Popularize
